<div class="sort-area clearfix">
  <div class="float-right">
    <div class="txt-sort">{{ 'Sort by' | translate }}</div>
    <div class="sort-type">{{ sortText | translate }}</div>
    <div class="sort-by">
      <span (click)="toggleSort()"></span>
      <ul [ngClass]="{ 'show': isSort }">
        <li [ngClass]="{'active' : sortType === 'noise-level'}" (click)="sortNoiseLevel()">{{ 'Noise levels' | translate }}</li>
        <li [ngClass]="{'active' : sortType === 'city'}" (click)="sortCity()">{{ 'City' | translate }}</li>
        <li [ngClass]="{'active' : sortType === 'number'}" (click)="sortNumber()">{{ 'Number' | translate }}</li>
      </ul>
    </div>
    <div class="up-down">
      <span (click)="toggleUpdown()"></span>
      <ul [ngClass]="{ 'show': isUpDown }">
        <li [ngClass]="{'active' : upDown === 0}" (click)="ascending()">{{ 'Ascending' | translate }}</li>
        <li [ngClass]="{'active' : upDown === 1}" (click)="descending()">{{ 'Descending' | translate }}</li>
      </ul>
    </div>
  </div>
</div>
<div class="scroll-box">
  <table class="tbl-area">
    <tbody>
      <tr *ngFor="let area of result | paginate: { itemsPerPage: 20, currentPage: p }">
        <td>
          <span>
            <img [src]="area.photo" onError="src='assets/images/no-image.png'" alt="Area">
          </span>
        </td>
        <td width="25%">{{ area.name.substr(0, 4) | translate }} {{ area.name.substr(5) }}{{ 'is' | translate }}
          <span class="bg-span" [ngClass]="area.color">{{ area.noise_status | translate }}</span>
        </td>
        <td>{{ area.textTime }}</td>
        <td>{{ area.address }}</td>
        <td>
          <a routerLink="/area-detail/{{ area.id }}" class="more-detail" (click)="savePage(area.id)">{{ 'More Details' | translate }}</a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="pagination-box">
  <pagination-controls (pageChange)="p = $event" lang="{{ langPagination }}" (checkChange)="scrollTop()"></pagination-controls>
</div>